export default {
    init() {
        // JavaScript to be fired on the home page

        $('.slider-actus-thumb').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.slider-actus-main',
            vertical: true,
            focusOnSelect: true,
        });

        $('.slider-actus-main').slick({
            arrows: false,
            asNavFor: '.slider-actus-thumb',
            fade: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        autoplay: true,
                        autoplaySpeed: 4000
                    },
                },
            ],
        });

        $('.instagram-pics').slick({
            slidesToShow: 6,
            slidesToScroll: 2,
            arrows: false,
            infinite: false,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });

        //avoid height problem
        $(window).resize(function(){
            $('.slider-actus-thumb').slick('reinit');

            $('.slider-actus-main').slick('reinit');

            $('.instagram-pics').slick('reinit');
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js